/* eslint-disable */

import type { ClosuresLang } from "./types/ClosuresLang";

let data: ClosuresLang | undefined;

export type { ClosuresLang };

export default function ClosuresLangFactory(): ClosuresLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setClosuresLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/ClosuresLangDef").then(({ ClosuresLangDef }) => {
      data = ClosuresLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/ClosuresLangDef").then(({ ClosuresLangDef }) => {
      data = ClosuresLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/ClosuresLangDef").then(({ ClosuresLangDef }) => {
      data = ClosuresLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/ClosuresLangDef").then(({ ClosuresLangDef }) => {
      data = ClosuresLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

